export const VERSION = '1.1.0';
export const BUILD_VERSION = '20200513-20200518.2';
